import {axiosInstance} from './axios';

export async function getDriversApi(query="false") {
  try {
    return await axiosInstance.get(`/api/v1/drivers?disabled=${query}`)
  }catch (e) {
    return null;
  }
}

export async function addDriversApi(data) {
  try {
    return await axiosInstance.post("/api/v1/drivers",data)
  }catch (e) {
    console.log(e)
    return {err:e};
  }
}


export async function assignBusToDriver(data,id) {
  try {
    return await axiosInstance.post(`/api/v1/drivers/${id}/assign-bus`,data)
  }catch (e) {
    return null;
  }
}

export async function getDriverApi(id) {
  try {
    return await axiosInstance.get(`/api/v1/drivers/${id}`)
  }catch (e) {
    return null;
  }
}
export async function editDriverApi(data,id) {
  try {
    return await axiosInstance.put(`/api/v1/drivers/${id}`,data)
  }catch (e) {
    return null;
  }
}

export async function removeDriverApi(id) {
  try {
    return await axiosInstance.delete(`/api/v1/drivers/${id}`)
  }catch (e) {
    return null;
  }
}
